import React from "react"
import ThirdStepTable from "./CreditReportTable/ThirdStepTable/ThirdStepTable";

const ThirdStep = ({ data }) => {
  return (
    <div className="mt-6">
      <div className="text-lg-18 font-bold text-text-primary my-6">Payment Schedule</div>
      <ThirdStepTable data={data} />
    </div>
  )
}
export default ThirdStep